module.exports = __webpack_public_path__ + "img/39.148f5454.jpg";